// Services
import { getEnvironmentApiUrl } from "../services/General";
import { getUser } from "../services/Auth";

// Hooks
import { useCallback } from "react";
import useHttp from "./useHttp";

// Interfaces
import { UIPersistenceKeys, UserUIPersistence } from "../interfaces/UserInfo";

const useUiPersistanceApi = () => {


    const { sendRequest: getUserUIPersistence } = useHttp<UserUIPersistence[]>();
    const { sendRequest: setUserUIPersistence } = useHttp();

    const get = useCallback((callback: (data: UserUIPersistence[]) => void) => {
        getUserUIPersistence({
            url: getEnvironmentApiUrl() + 'user_ui_persistence/all',
            method: 'POST',
            body: { params: {}, filter: { user_id: getUser().id }, },
        }, callback);
    }, [getUserUIPersistence]);

    const set = useCallback((key: UIPersistenceKeys, value: string) => {
        setUserUIPersistence({
            url: getEnvironmentApiUrl() + 'user_ui_persistence/set',
            method: 'POST',
            body: { params: {}, filter: { user_id: getUser().id, case_id: null, key, value } }
        });
    }, [setUserUIPersistence]);

    return { get, set };

};

export default useUiPersistanceApi;